import { render, staticRenderFns } from "./HospitalContactAdd.vue?vue&type=template&id=5a7f6118&scoped=true&"
import script from "./HospitalContactAdd.vue?vue&type=script&lang=js&"
export * from "./HospitalContactAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f6118",
  null
  
)

export default component.exports